export default [
     {
          id: 1,
          clientImg: "../images/rectangle8.png",
          headImg: "../images/Vector41.png",
          contentEx: "Take care of your ",
          content: "Take care of your pet,never leave them sick and weak .we are here to help you treat your pets",
          bottomImg:"../images/Vector40.png"
          

          
     },
     {
          id: 2,
          clientImg: "../images/rectangle9.png",
          headImg: "../images/Vector41.png",
          content: "Take care of your pet,never leave them sick and weak .we are here to help you treat your pets",
          contentEx: "Take care of your ",
          bottomImg:"../images/Vector40.png"
     
     },
     {
          id: 3,
          clientImg: "../images/rectangle8.png",
          headImg: "../images/Vector41.png",
          contentEx: "Take care of your ",
          content: "Take care of your pet,never leave them sick and weak .we are here to help you treat your pets",
          bottomImg:"../images/Vector40.png"
          

          
     },
   
     


   
]
